import React from "react";
import {connect} from 'react-redux'

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import IconButton from "@material-ui/core/IconButton";

import WarningTooltip from "../../../../components/WarningTooltip";
import PrimaryButton from "../../../../components/Buttons/PrimaryButton";
import CustomersSelectionModal
  from "../../../ProductComparison/components/CustomerSelectionModal/ProductSourceSelectionModal";
import {ModelPortfolioResource} from "../../../../utils/api";
import {displayErrorSnackBar, displaySuccessSnackBar} from "../../../../components/SnackbarProvider/actions";
import {SERVER_ERROR} from "../../../../utils/constants";


const Icon = () => <FontAwesomeIcon icon={['fa', 'analytics']} fixedWidth/>;

const AddToCustomerButton = (props) => {
  const {onlyIcon, customClasses, item, dispatch} = props;

  const [isOpen, setOpen] = React.useState(false);
  const [isCopyInProgress, setCopyInProgress] = React.useState(false);

  const title = 'Zu Kunden hinzufügen';
  const openCustomerSelection = () => setOpen(true);
  const closeSelection = () => setOpen(false);

  const copyToCustomer = (selectedCustomers) => {
    const customer = selectedCustomers[0];

    setCopyInProgress(true);
    ModelPortfolioResource.cloneToCustomer(item.id, customer.customer_id)
      .then(() => dispatch(displaySuccessSnackBar('Musterdepot erfolgreich zur Vermögensübersicht des Kunden hinzugefügt.')))
      .catch(() => {
        dispatch(displayErrorSnackBar(SERVER_ERROR))
      }).finally(() => {
        setCopyInProgress(false);
        closeSelection();
      });
  };

  return (
    <>
      {onlyIcon ? (
        <WarningTooltip
          title={title}
          classes={customClasses}
          icon={
            <IconButton color={"primary"} onClick={openCustomerSelection}>
              <Icon />
            </IconButton>
          }
        />
      ) : (
        <PrimaryButton
          text={title}
          variant={"text"}
          onButtonClick={openCustomerSelection}
          icon={<Icon />}
          classes={customClasses}
        />
      )}
      <CustomersSelectionModal
        open={isOpen}
        onClose={closeSelection}
        title={<>Im Vermögensüberischt folgender Kunden importieren <WarningTooltip title={'Fügen Sie eine Kopie des Musterdepots als simuliertes Depot zur Vermögensübersicht eines ausgewählten Kunden hinzu.'} /></>}
        confirmText={'In Vermögensübersicht hinzufügen'}
        singleSelection
        onSelect={copyToCustomer}
        modalLoading={isCopyInProgress}
      />
    </>
  )
};

export default connect()(AddToCustomerButton);